module.exports = __webpack_public_path__ + "assets/images/base_roads_phase1.a139ea9b7707d44631a1d08183f9178f.svg";